<template lang="pug">
  div
    ReloadAppDialog(:showDialog="showDialog")
    b-row.top-bar
      notifications(group="request" position="top center")
    b-row.justify-content-md-center
      b-col(md="10")
        b-table(hover :fields="categoryFields" :items="categories" striped=true)
          template(slot="color" scope="category")
            div.cell-matrix-color.d-flex.align-items-center
            span.cell-matrix-color__label {{ category.item.color }}
            span.cell-matrix-color__preview(
              :style="{ 'background-color': category.item.color }"
            )
          template(slot="actions" scope="category")
            b-button(class="icon-button" variant="link" v-b-tooltip.hover.top="'Editar'" @click="loadCategory(category.item)")
              icon(name="edit")
        b-pagination(align="center", :total-rows="pagination.total" v-model="pagination.current",
        :per-page="pagination.per_page" ,@change="changePage" v-if="categories.length > 0")
    b-form.form-horizontal(@submit="onSubmit")
      b-modal(v-model="modalShow", :busy="true", size="lg" :title="`Editar Categoría ${category.name}`" no-close-on-backdrop=true @hide="closeModal(category)")
        b-row
          b-col(md="12")
            b-form-group(label="Urgencia")
              b-form-select(v-model="category.urgency" v-validate="'required'" data-vv-as="urgency" name="category[urgency]" :options="urgency_options" autocomplete="off")
              span.danger(v-show="errors.has('category[urgency]')") {{ errors.first('category[urgency]') }}
          b-col(md="6")
            b-form-group(label="Usar color")
              ToggleSwitch(v-model="category.use_color" :disabled="disableUseColor")
        div(slot="modal-footer")
          b-btn.btn-space(variant="secondary", @click="closeModal(category)") Cancelar
          b-btn.btn-space(variant="primary", type="submit") Actualizar
</template>

<script>
import kexaApi from '@/services/apiService';
import categoriesPerimeter from '@/perimeters/categoriesPerimeter';
import ToggleSwitch from './ui/ToggleSwitch';

const parse = require('parse-link-header');

export default {
  name: 'categories',
  components: {
    ToggleSwitch,
  },
  data() {
    return {
      categoryFields: {
        name: { label: 'Categoría', sortable: true },
        urgency: {
          label: 'Urgencia',
          sortable: true,
          formatter: value => ({
            1: 'Normal',
            2: 'Medio',
            3: 'Urgente',
          }[value] || 'Desconocido'),
        },
        color: { label: 'Color', sortable: false },
        use_color: {
          label: 'Usar color',
          sortable: true,
          formatter: value => (value ? 'SI' : 'NO'),
        },
        actions: { label: 'Acciones' },
      },
      categories: [],
      category: {},
      modalShow: false,
      disableUseColor: false,
      pagination: {},
      current_page: 1,
      urgency_options: [
        { value: 1, text: 'Normal' },
        { value: 2, text: 'Medio' },
        { value: 3, text: 'Urgente' },
      ],
      showDialog: false,
      intervalId: null,
    };
  },
  perimeters: [categoriesPerimeter],
  created() {
    this.fetchCategories(1);
  },
  beforeMount() {
    this.refreshReloaAppStatus();
  },
  methods: {
    fetchCategories(page) {
      kexaApi.get_categories(page).then((data) => {
        this.categories = data.body;
        this.setPagination(data);
      });
    },
    setPagination(res) {
      const links = Object.prototype.hasOwnProperty.call(res.headers.map, 'links')
        ? parse(res.headers.map.link[0])
        : null;
      const pagination = {
        current: parseInt(res.headers.map.page, 10),
        total: parseInt(res.headers.map.total, 10),
        per_page: parseInt(res.headers.map['per-page'], 10),
        ...links,
      };
      this.pagination = pagination;
    },
    changePage(page) {
      this.current_page = page;
      this.fetchCategories(page);
    },
    loadCategory(category) {
      this.beforeEditingCache = Object.assign({}, category);
      this.category = category;
      this.modalShow = true;
    },
    updateCategory() {
      kexaApi.update_category(this.category, this.category.id).then(() => {
        this.modalShow = false;
        this.fetchCategories(this.current_page);
        this.$notify({
          group: 'request',
          type: 'success',
          title: 'Categoría modificada con éxito',
          duration: 3000,
        });
      }).catch((response) => { this.notifyError(response); });
    },
    closeModal(category) {
      Object.assign(category, this.beforeEditingCache);
      this.$validator.reset();
      this.modalShow = false;
    },
    onSubmit(event) {
      event.preventDefault();
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.updateCategory();
        }
      });
    },
    notifyError(response) {
      this.$notify({
        group: 'request',
        type: 'error',
        title: 'Error',
        text: response.body,
        duration: 3000,
      });
    },
    refreshReloaAppStatus() {
      this.intervalId = setInterval(() => {
        kexaApi.reloadAppStatus().then((response) => {
          if (response.body) {
            this.showDialog = true;
          }
        });
      }, 900000);
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  watch: {
    category: {
      handler(newCategory) {
        if (newCategory.urgency === 1) {
          this.category.use_color = false;
          this.disableUseColor = true;
        } else {
          this.disableUseColor = false;
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
  .btn-space {
    margin-right: 5px;
  }

  .top-bar {
    margin-bottom: 10px;
  }

  .icon-button {
    color: black;
  }

  span.danger {
    color: red;
    font-size: 12px;
  }

  .color-input {
    width: 33px;
    height: 30px;
  }

  .cell-matrix-color {
    &__label {
      display: inline-block;
      text-align: center;
      width: 4rem;
    }

    &__preview {
      display: inline-block;
      margin-left: 0.75rem;
      margin-bottom: -1px;
      border-radius: 0.25rem;
      width: 0.75rem;
      height: 0.75rem;
      border: 1px solid;
      border-color: rgba(0, 0, 0, 0.5);
    }
  }

  .compact-switch {
    position: relative;
    display: inline-block;
    width: 46px;
    height: 24px;
  }

  .compact-switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .compact-switch .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
    border-radius: 24px;
  }

  .compact-switch .slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 19px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: .4s;
    border-radius: 50%;
  }

  .compact-switch input:checked + .slider {
    background-color: #2196F3;
  }

  .compact-switch input:checked + .slider:before {
    transform: translateX(21px);
  }

  .compact-switch input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
  }
</style>



// WEBPACK FOOTER //
// src/components/Categories.vue